import queryString from 'qs';

const getSisoTableRequest = (filters) => {
    const payload = {
        month: filters?.tableMonth,
        year: filters?.tableYear,
        nama_dc: filters?.dcName && `[${filters?.dcName}]`,
        customer: filters?.customer && `[${filters?.customer}]`,
        sales_area: filters?.salesArea && `[${filters?.salesArea}]`,
        brand: filters?.brands && `[${filters?.brands}]`,
        store_group: filters?.storeGroup && `[${filters?.storeGroup}]`,
    };

    return queryString.stringify(payload, { skipEmptyString: true, arrayFormat: 'separator' });
};

export default getSisoTableRequest;
